export default __webpack_public_path__ + "e664fe65d5b983a0661bdfffdbf171b2.svg";